export const getPaymentOption = (paymentMethods) => {
  const showCod = paymentMethods.cod;
  const showOnlineMethods = paymentMethods.online;
  let obj = {};
  if (showOnlineMethods && showCod)
    obj = '{payment_options_displayed:Prepaid,Cod}';
  else if (showOnlineMethods && !showCod)
    obj = '{payment_options_displayed:Prepaid}';
  else if (!showOnlineMethods && showCod)
    obj = '{payment_options_displayed:Cod}';
  return obj;
};
